export const hasRecipeConfiguration = (product) =>
  Boolean(product?.config?.recipe || product?.config?.isIceCream || product?.config?.promotion?.enabled) ||
  String(product?.type || '').toLowerCase() === 'receta' ||
  Array.isArray(product?.recipeComponents);

// La existencia informa y se descuenta, pero nunca bloquea una venta. Así el POS,
// Mesero y Cocina comparten la misma política y los faltantes quedan visibles como
// inventario negativo para su posterior ajuste.
export const requiresDirectStock = () => false;

// Define si una venta sin componentes debe descontar el producto directamente.
// Permitir stock negativo no significa dejar de registrar el movimiento.
export const tracksDirectStock = (product) => {
  if (!product || hasRecipeConfiguration(product)) return false;
  return product.trackStock !== false;
};

// Centraliza el comportamiento de los editores de cantidad del POS y Mesero.
// Toda cantidad positiva se permite aunque la existencia actual sea cero o negativa.
export const resolveRequestedSaleQuantity = (product, requestedQuantity) => {
  const requested = Math.max(1, Number.parseInt(requestedQuantity, 10) || 1);
  return { allowed: true, quantity: requested, requested, available: null, capped: false };
};
